import { API_CUSTOM_HEADERS } from '@endion/types';

export function getEndpoint(path: string) {
  return `${import.meta.env.VITE_ENDION_API_URL}/${path}`;
}

export async function callApi<Data>(url: string, requestOptions: Partial<RequestInit>): Promise<Data> {
  const { method, body } = requestOptions;

  const headers = new Headers(requestOptions.headers);
  if (window.endion_debug?.simulatedOrigin) {
    headers.set(API_CUSTOM_HEADERS['X_SIMULATED_ORIGIN'], window.endion_debug.simulatedOrigin);
  }

  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...Object.fromEntries(headers.entries()),
    },
    body,
  });

  if (!res.ok) {
    throw await res.json();
  }

  return res.json();
}
